import type { AssetWorkflowOptions } from '../../types';

export const addAugmentationSetWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addAugmentationSetWorkflow',
  workflowIndex: 1,
  assetType: 'augmentationSet',
  workflowConditionalMatcher: [
    {
      assetType: 'labelAugmentation',
      schema: {
        type: 'array',
        minItems: 1,
      },
    },
  ],
  workflowType: 'addAssetWorkflow',
  workflowName: 'Add Augmentation Set Workflow',
  overrideSave: 'addAugmentationSet',
  workflowDescription: `Create a set of rules for applying label augmentations to shipments`,
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Agumentation Set ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this augmentation set',
        description: 'This is optional but will allow you to more easily reference this augmentation set in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Augmentation Set Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'How do you want to refer to this augmentation set?',
        description:
          'Tell us what you want to call this augmentation set. The fulfillment center that they will apply at is a good choice.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'augmentationSetDescription',
      workflowStepNavigationName: 'Augmentation Set Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 4,
        prompt: 'Enter a description (optional):',
        description: '',
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'augmentations',
      workflowStepNavigationName: 'Augmentations',
      workflowComponent: {
        workflowComponentType: 'assetSetSelect',
        description: '',
        prompt: 'Select augmentations that will apply to labels regardless of carrier and method',
        help: '',
        assetType: 'labelAugmentation',
        assetIdProperty: 'labelAugmentationId',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'augmentationIds',
      },
    },
    {
      workflowStepKey: 'carrierAugmentations',
      workflowStepNavigationName: 'Carrier Augmentations',
      workflowComponent: {
        workflowComponentType: 'carrierAugmentationSelect',
        title: 'Carrier Augmentations',
        prompt: 'Select augmentations that will apply to labels based on carrier',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierAugmentations',
      },
    },
    {
      workflowStepKey: 'serviceMethodAugmentations',
      workflowStepNavigationName: 'Service Method Augmentations',
      workflowComponent: {
        workflowComponentType: 'serviceMethodAugmentationSelect',
        title: 'Service Method Augmentations',
        prompt: 'Select augmentations that will apply to labels based on service methods',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierServiceMethodAugmentations',
      },
    },
    {
      workflowStepKey: 'carrierAccountSummary',
      workflowStepNavigationName: 'Augmentation Set Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Augmentation Set Summary',
        description: 'The following values will be saved.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
